// src/components/GeneralLoanHome.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import '../AdminDashboard.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const GeneralLoanHome = () => {
  return (
    <div className="dashboard-container">
      <aside className="sidebar">
        <div className="asd"><p>General Loan</p></div>
        <nav>
          <ul>
            <li>
              <NavLink to="/general-loan/new" activeClassName="active-link">
                <i className="fas fa-file-alt"></i> New General Loan
              </NavLink>
            </li>
            <li>
              <NavLink to="/general-loan/receiver" activeClassName="active-link">
                <i className="fas fa-money-check-alt"></i> Loan Receiver
              </NavLink>
            </li>
            <li>
              <NavLink to="/general-loan/ledger" activeClassName="active-link">
                <i className="fas fa-book"></i> Loan Ledger
              </NavLink>
            </li>
            <li>
              <NavLink to="/general-loan/reports" activeClassName="active-link">
                <i className="fas fa-chart-pie"></i> Loan Reports
              </NavLink>
            </li>
            <li>
              <NavLink to="/general-loan/partnerwise-report" activeClassName="active-link">
                <i className="fas fa-user-friends"></i> Partnerwise Report
              </NavLink>
            </li>

            {/* ✅ New Menu Item */}
            <li>
              <NavLink to="/general-loan/monthly-cashbook" activeClassName="active-link">
                <i className="fas fa-calendar-alt"></i> Monthly Cashbook
              </NavLink>
            </li>

            <li>
              <NavLink to="/general-loan/due-report" activeClassName="active-link">
                <i className="fas fa-exclamation-triangle"></i> Due Report
              </NavLink>
            </li>
            <li>
              <NavLink to="/general-loan/partnerwise-due-report" activeClassName="active-link">
                <i className="fas fa-users"></i> Partnerwise Due Report
              </NavLink>
            </li>

            <li>
              <button onClick={() => window.history.back()} className="back-buttonnn">
                Back
              </button>
            </li>
          </ul>
        </nav>
      </aside>

      <main className="content">
        <h2>Welcome to the General Loan Section</h2>
        <p>Select an option from the menu to proceed.</p>
      </main>
    </div>
  );
};

export default GeneralLoanHome;
